<app-wizard-bar-nav> </app-wizard-bar-nav>

<div class="step-container main-content">
  <app-youre-done-content [youreDone]="this.youreDone" [quoteRequestState]="this.quoteRequestState"></app-youre-done-content>
</div>

<app-wizard-step-nav-buttons [hideNext]="true" (backClicked)="back()"></app-wizard-step-nav-buttons>
